import CartProductCard from 'features/shop/cart/CartProductCard';

/**
 * CartFrozenItems - Displays frozen items section in the shopping cart
 *
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes for styling the main section
 * @param {string} [props.itemsContainerClassName] - Additional CSS classes for the items container
 * @param {number} [props.frozenFee] - Fee amount for frozen items (displayed if provided)
 * @param {Array<Object>} props.frozenItems - Array of frozen product objects
 * @param {number} props.frozenItemsQty - Total quantity of frozen items
 * @param {Function} props.onProductClick - Callback function when a product is clicked
 * @param {boolean} props.plusMembershipEligibleOrder - Whether the order is eligible for plus membership pricing
 * @param {string} props.plusMembershipShortBranding - Short branding text for plus membership (e.g., 'M+', 'IF+')
 *
 * @returns {JSX.Element|null} Rendered component or null if no frozen items
 */
function CartFrozenItems({
    className,
    frozenFee,
    frozenItems,
    frozenItemsQty,
    itemsContainerClassName,
    onProductClick,
    plusMembershipEligibleOrder,
    plusMembershipShortBranding,
}) {
    if (frozenItems.length === 0) {
        return null;
    }

    return (
        <section className={className} data-testid="cart-frozen-items-section">
            <h3 className="text-body-md mb-10 scroll-mt-10 font-grotesk-bold">Frozen ({frozenItemsQty})</h3>
            <div className={itemsContainerClassName}>
                {frozenFee && (
                    <p className="text-body-xs mb-10 text-grey">
                        ${frozenFee?.toFixed(2)} Frozen Packaging Fee applies. These items ship with dry ice and special
                        packaging to keep them frozen in transit.
                    </p>
                )}
                <div className="flex flex-col gap-30">
                    {frozenItems.map((product) => (
                        <CartProductCard
                            key={product.id}
                            plusMembershipEligibleOrder={plusMembershipEligibleOrder}
                            plusMembershipShortBranding={plusMembershipShortBranding}
                            onClick={() => onProductClick({ productId: product.id })}
                            product={product}
                            usePlusMemberPrice
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CartFrozenItems;
